import { render, staticRenderFns } from "./UpdateCardDialog.vue?vue&type=template&id=11011434&scoped=true"
import script from "./UpdateCardDialog.vue?vue&type=script&lang=js"
export * from "./UpdateCardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11011434",
  null
  
)

export default component.exports